module.exports = __webpack_public_path__ + "static/media/telefono.bb392619.png";